<template name = "dateTemplate" lang="html">
	<div class="row">
		<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
			</div><!-- df-sidebar-header -->
			<div class="sidebar-body">
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item active" aria-current="page">{{this.subName}}</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
						</nav>
					</div>
				</div>
				<div class="row row-xs">
					<div class="col-sm-6 col-lg-12">
						<div class="card card-body flex-column-inherit">
							<div class="col-sm-6 col-lg-5 d-inline-block">
								<h6>Menu Depth 1</h6>
								<draggable class="list-group" :list="setMenu" group="dept0" @change="log">
									<div class="list-group-item list-group-item-padding" v-for="(form, i) in setMenu" :key="form.id">
										<input type="text" class="form-control display-inline-block w-40" v-model="form.menuName" id="menuName" placeholder='name'>
										<input type="text" class="form-control display-inline-block w-20" v-model="form.menuRoute" id="menuRoute" placeholder='route'>
										<input type="text" class="form-control display-inline-block w-10" style="text-transform: uppercase" maxlength="2" v-model="form.menuAbbr" v-on:keyup="engOnlyEvent(1, i)" placeholder='abbr'>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="menuEdit(1, form, i + 1)">
											<feather type="edit" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="menuDelete(1, form, i + 1)">
											<feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="nextMenu(form.id, form.menuDepth)">
											<feather type="menu" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
									</div>
								</draggable>
								<div class='pt-2'>
									<input type="text" class="form-control display-inline-block w-80" @keyup="menuAdd(1)" id="menuName" ref="menuName" v-model="menuName1" placeholder='name'>
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="menuAdd(1)">
										<feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add
									</a>
								</div>
							</div><!-- col -->
							<div class="col-sm-6 col-lg-5" :class="{'d-none': secondDisplay}">
								<div class="dept-margin-bottom"><h6 class="display-inline-block">Menu Depth 2</h6><feather type="x-square" @click="menuClosed(1)" class="wd-15 hd-15 valign-middle-f svg_overflow float-right closed-cursor"></feather></div>
								<draggable class="list-group" :list="secondMenu" group="dept1" @change="log">
									<div class="list-group-item list-group-item-padding" v-for="(form, i) in secondMenu" :key="form.id">
										<input type="email" class="form-control display-inline-block w-40" v-model="form.menuName" placeholder='name'>
										<input type="email" class="form-control display-inline-block w-20" v-model="form.menuRoute" placeholder='route'>
										<input type="email" class="form-control display-inline-block w-10" style="text-transform: uppercase" maxlength="2" v-model="form.menuAbbr" v-on:keyup="engOnlyEvent(2, i)" placeholder='abbr'>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="menuEdit(2, form, i + 1)">
											<feather type="edit" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="menuDelete(2, form, i + 1)">
											<feather type="trash-2" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
										<!-- <a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="nextMenu(form.id, form.menuDepth)">
											<feather type="menu" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a> -->
									</div>
								</draggable>
								<div class='pt-2'>
									<input type="email" class="form-control display-inline-block w-80" v-model="menuName2" placeholder='name'>
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="menuAdd(2)">
										<feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add
									</a>
								</div>
							</div><!-- col -->
							<!-- <div class="col-sm-6 col-lg-2" :class="{'d-none': thirdDisplay}">
								<div class="dept-margin-bottom"><h6 class="display-inline-block">Menu Depth 3</h6><feather type="x-square" @click="menuClosed(2)" class="wd-15 hd-15 valign-middle-f svg_overflow float-right closed-cursor"></feather></div>
								<draggable class="list-group" :list="thridMenu" group="dept2" @change="log">
									<div class="list-group-item list-group-item-padding" v-for="(form, i) in thridMenu" :key="form.id">
										<span type="email" class="display-inline-block w-50">{{form.menuName}}</span>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="menuDelete">
											<feather type="repeat" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
										<a href="" class="btn btn-xs pd-x-5 btn-secondary btn-uppercase" data-toggle="modal" data-animation="effect-flip-horizontal" @click="menuDelete">
											<feather type="delete" class="wd-15 hd-15 valign-middle-f svg_overflow"></feather>
										</a>
									</div>
								</draggable>
							</div>col -->
						</div>
					</div>
				</div><!-- row row-xs -->
			</div><!-- container -->
		</div><!-- content -->
	</div>
</template>
<script>
	// 공통 스크립트
	import common from "@/views/Common/common.js";
	// Header의 메뉴 정보 호출을 위한 bus event
	import { bus } from "../../../main";
	// vue draggable api import
    import draggable from "vuedraggable";

    import { Buefy } from 'buefy';

	export default {
		name: "Department",
		// order: 1,
		props: ['properties'],
		data() {
			return {
				mainName:'',
				subName:'',
				menuData:[], // header.vue data
                menuAll: [], // 부서정보
                menuDepth: [],
				setMenu: [], // 초기 Depth Setting
				secondMenu: [],
				secondDisplay: true,
                thirdDisplay: true,
                
                menuName1: '', //depth 1 메뉴네임
                menuName2: '', //depth 2 메뉴네임

                parentId: '',
                
			}
		},
		beforeDestroy(){
			bus.$off('menu_data')
		},
		created(){
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.classifyMenu();
			});
		},
		mounted() {
		},
		components: {
			draggable
		},
		methods: {
            engOnlyEvent(menuDepth, idx) {
                const reg = /^[a-zA-Z]+$/;
                let val = '';
                if (menuDepth === 1) {
                    val = this.setMenu[idx].menuAbbr;
                } else {
                    val = this.secondMenu[idx].menuAbbr;
                }
                if(reg.exec(val)==null){
                    this.$notification.open({
                        duration: 2000,
                        message: `Please enter only English`,
                        position: 'is-bottom-right',
                        type: 'is-danger',
                        hasIcon: true
                    })
                }
            },
			/*
			* Load Data Menu
			*/
			async classifyMenu(){
				let data = common.menuHeader(this.properties.mid, this.menuData);
				this.mainName = data[0];
				this.subName = data[1];
                this.setMenu = [];

                await this.$axios.get(this.$apiHost + "/menus")
				.then(res => {
                    this.menuAll = res.data;
				})
                .catch(error => {throw error;});
                this.menuAll.sort((a, b)=>{return a.menuDepth - b.menuDepth;}); // 정렬 이후 make data
				this.menuAll.forEach(a=>{
                    if(Number(a.menuDepth) === 1) this.setMenu.push(a);
                    // else if (a.menuDepth === 2) {
                        
                    // }
				}); // dept Setting
				this.setMenu.sort((a, b)=>{return a.menuSort - b.menuSort;}); // setDept sort
				
			},
			async createData() {
			},
			async deleteData() {
			},
			menuAdd: function(menuDepth) {
                if (menuDepth === 1) {
                    this.setMenu.push({menuName:this.menuName1});
                    this.menuName1 = '';
                    this.menuClosed(1);
                } else if (menuDepth === 2) { 
                    this.secondMenu.push({menuName:this.menuName2});
                    this.menuName2 = '';
                }
 				// this.list1.push({ name: "Juan ", id: 9});
			},
			menuReplace: function() {
				this.list1 = [{ name: "Edgard" }];
			},
			async menuEdit(menuDepth, menuData, rowNum) {
                if (menuData.menuName == '') {
                    this.$buefy.dialog.alert({
                        message: 'Please write a menuname.',
                        size: 'is-medium',
                        type: 'is-danger'
                    })
                    return false;
                }

                this.$buefy.dialog.confirm({
                    message: 'Continue on this task?',
                    size: 'is-medium',
                    onConfirm: async () => {
                        try {
                            if (!menuData.id) { //create
                                
                                menuData.menuDepth = menuDepth;
                                menuData.menuSort = rowNum;

                                if (menuDepth === 2) {
                                    menuData.parentId = this.parentId;
                                } 

                                const create = await this.$axios.post(this.$apiHost + '/menus', menuData);
                            
                                this.menuAll = create.data.menus;
                                this.menuAll.sort((a, b)=>{return a.menuDepth - b.menuDepth;}); 
                                delete create.data.menus; 

                                if (menuDepth === 1) {
                                    this.setMenu[rowNum-1] = create.data;
                                } else {
                                    this.secondMenu[rowNum-1] = create.data;
                                }
                                this.$buefy.dialog.alert({
                                    message: 'The operation has been done',
                                    size: 'is-medium'
                                })
                            } else { // update
                                const update = await this.$axios.patch(this.$apiHost + '/menus' + '/update', menuData);

                                if (update.data === 'Complete') {
                                    this.$buefy.dialog.alert({
                                        message: 'The operation has been done',
                                        size: 'is-medium'
                                    })
                                }
                            }
                        
                        } catch (error) {
                            console.log(error)
                        } 
                    }
                })
			},
            async menuDelete(menuDepth, menuData, rowNum) { 
            
                try {
                    this.$buefy.dialog.confirm({
                        message: 'Continue on this task?',
                        size: 'is-medium',
                        onConfirm: async () => {
                            let tempData = {};
                            if (!menuData.id) { //저장 안되거나 방금 저장한 데이터 

                                if (menuData.menuDepth === 1) { 
                                    menuData = this.setMenu[menuData.menuSort-1];
                            
                                } else {
                                    menuData = this.secondMenu[menuData.menuSort-1];
                                }
                                if (menuData === undefined) { //저장안한 데이터
                                    if (menuDepth === 1) {
                                        this.setMenu.splice(rowNum-1,1);

                                    } else {
                                        this.secondMenu.splice(rowNum-1,1);
                                    }
                                    return false;
                                } 
                            }

                            if (menuData.menuDepth === 1) {
                                tempData = {
                                    id: menuData.id,
                                    menuDepth: menuData.menuDepth,
                                    menuSort: menuData.menuSort,
                                }
                            } else {
                                tempData = {
                                    id: menuData.id,
                                    menuDepth: menuData.menuDepth,
                                    menuSort: menuData.menuSort,
                                    parentId: menuData.parentId,
                                    statusCode: menuData.statusCode
                                }
                            }
                            const data = tempData;

                            //delete 
                            const result = await this.$axios.patch(this.$apiHost + '/menus' + '/delete',data);
                            if (result.data.message) {
                                 this.$buefy.dialog.alert({
                                    message: result.data.message,
                                    size: 'is-medium'
                                })

                                if (result.data.message === 'Complete') {
                                    if (menuDepth === 1) {
                                        this.setMenu.splice(rowNum-1,1);
        
                                    } else {
                                        this.secondMenu.splice(rowNum-1,1);
                                    }
                                }
                                return false;
                            }

                        } 
                    });
                
                    
                } catch (error) {
                    
                }

			},
			menuClosed: function(gubun) {
				if(gubun === 1) this.secondDisplay = true;
				else this.thirdDisplay = true;
			},
			nextMenu: function(parentId, menuDepth) {
				if (menuDepth === 1) {
                    this.parentId = parentId;
					this.secondDisplay = false;
					this.thirdDisplay = true;
					this.secondMenu = [];
					this.thirdMenu = [];
					this.menuAll.forEach(a=>{
						if(a.parentId === parentId) this.secondMenu.push(a);
					});
					this.secondMenu.sort((a,b)=>{return a.menuSort - b.menuSort;});
                } else if (menuDepth === 2) {
					this.thirdDisplay = false;
					this.thirdMenu = [];
					this.menuAll.forEach(a=>{
						if(a.parentId === parentId) this.thirdMenu.push(a);
					});
					this.thirdMenu.sort((a,b)=>{return a.menuSort - b.menuSort;});
				}

			},
			async log(evt) {
                let oldData = evt.moved.element;
                let changeData = [];

                if (evt.moved.element.id) {
                    if (oldData.menuDepth === 1) {
                        for (let i in this.setMenu) {
                            changeData.push({id:this.setMenu[i].id, menuSort: Number(i)+1})
                        }
                    } else if (oldData.menuDepth === 2) {
                        for (let i in this.secondMenu) {
                            changeData.push({id:this.secondMenu[i].id, menuSort: Number(i)+1})
                        }
                    }
                    const sort = await this.$axios.patch(this.$apiHost + '/menus' + '/sort', changeData);
                    if (sort.data === 'Complete') {
                        this.$notification.open({
                            duration: 2000,
                            message: `The operation has been done`,
                            position: 'is-bottom-right',
                            type: 'is-success',
                            hasIcon: true,
                        })
                        this.setMenu = [];
                        this.classifyMenu();
                    }
                } else {
                    this.$buefy.dialog.alert({
                        message: 'Save it first.',
                        size: 'is-medium'
                    })
                    this.setMenu = [];
                    this.secondMenu = [];
                    this.classifyMenu();
                    // let flag = confirm('Save it first. Would you like to save?');
                }

            },
        },
		computed: {
			draggingInfo() {
				return this.dragging ? "under drag" : "";
			}
		},
		watch: {
		},
	}
</script>
<style scoped>
	@import "../../../assets/css/buefy.css";
</style>


// WEBPACK FOOTER //
// src/views/Management/Menu/List.vue